import styled from '@emotion/styled';
import { Row } from 'react-bootstrap';
import Cols from 'components/Layout/Cols';
import Card from 'components/Card/Card';
import KizenTypography from 'app/kizentypo';
import { fontSizes, monoFontFamily } from 'app/typography';
import {
  contentWidthCss,
  CONTENT_MAX_WIDTH,
} from 'components/Layout/PageContentWidth';
import TextareaAutosize from 'react-autosize-textarea';

export const Container = styled.div`
  ${contentWidthCss}
  background-color: unset;

  & > div {
    margin-bottom: 20px;
    max-width: 100%;
  }
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledRow = styled(Row)`
  margin-bottom: 17px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledCols = styled(Cols)`
  display: flex;
  flex-direction: row;
  gap: 20px;
  max-width: ${CONTENT_MAX_WIDTH};
  width: ${CONTENT_MAX_WIDTH};
`;

export const StyledCard = styled(Card)`
  max-width: calc(50% - 10px);
  margin: unset;

  &:empty {
    padding: 0;
  }
`;

// override base styles
export const StyledTextArea = styled(TextareaAutosize)`
  font-family: ${monoFontFamily};
  border-radius: 4px !important;
  border-color: var(--color-border-medium) !important;
  margin-top: 0;
  width: 100%;
  padding: 15px;
  font-size: ${fontSizes.text};
  line-height: 125%;
  color: var(--color-background-darker);
  outline: none;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 15px;

  > button {
    margin: 0 !important;
  }
`;

export const StyledFormError = styled(KizenTypography)`
  margin-bottom: -3px;
  text-align: center;
  color: var(--color-viz-cat-7-primary);
`;

export const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  & li {
    position: relative;
    text-indent: 15px;
    margin-left: 10px;
  }

  & li p:before {
    content: '-';
    position: absolute;
    left: -10px;
  }
`;
